let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("cQ2OK"), load("c6MKV"), load("f0OaY")]).then(() => parcelRequire('bkgW7'));